const { USER_ROLE } = require('./userRoles');
const { ORDER_STATUS } = require('./orderStatus');
const { MEDICAL_FILE_CATEGORY, MEDICAL_FILE_SOURCE_TYPE, MEDICAL_FILE_STATUS, CLINICAL_TYPE } = require('./medicalFile');
const { FILE_VISIBILITY, FILE_SECURITY_CLASS, FILE_LINKED_ENTITY_TYPE, BUCKET_TYPE, FILE_UPLOAD_PURPOSE, UPLOAD_PURPOSE_CONFIG } = require('./files');

module.exports = {
  USER_ROLE,
  ORDER_STATUS,
  MEDICAL_FILE_CATEGORY,
  MEDICAL_FILE_SOURCE_TYPE,
  MEDICAL_FILE_STATUS,
  CLINICAL_TYPE,
  FILE_VISIBILITY,
  FILE_SECURITY_CLASS,
  FILE_LINKED_ENTITY_TYPE,
  BUCKET_TYPE,
  FILE_UPLOAD_PURPOSE,
  UPLOAD_PURPOSE_CONFIG,
};
